
import { Component, OnInit } from '@angular/core';
//import { FormBuilder } from '@angular/forms';
import {Http , Headers } from  '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Login_model} from'../../models/login_model';
import { Validation_model} from'../../models/Validation_model';
import{ AccountService} from'../../services/account.service';

@Component({
  selector: 'app-add-wearing',
  templateUrl: './add-wearing.component.html',
  styleUrls: ['./add-wearing.component.scss']
})
export class AddWearingComponent implements OnInit {
  public loginModel:Login_model;
  public addValidationError:Validation_model;
  private headers = new Headers();
  public getId: any = [];
  sucMsg: boolean = false;
  errMsg:boolean = false; 
  successMessage='Wearing Added successfully'; 
  errorMessage='Something went wrong'; 
 record:any=[];
 constructor(private accountService:AccountService,private route: ActivatedRoute,private router: Router,private http: Http ) { }

 ngOnInit(): void {
  this.loginModel=<Login_model>{
    type: '',
  }
  this.addValidationError = <Validation_model>{
    type: '',
    }

   this.getId = this.route.params.subscribe(params => {
     this.getId = params['id'];
   });
   this.isLoggedIn();
}
isLoggedIn() {
  this.loginModel.email = localStorage.getItem('email');
  if(this.loginModel.email == null){
  this.router.navigate(['/admin']);
  }
  }
     add_wearing(){
        var valid=true;
        this.addValidationError.type='';
        
        if(this.loginModel.type==""){
          this.addValidationError.type='Please Enter Wearing Type';
          valid=false; 
        }
        if(valid){
          this.accountService.add_wearings(this.loginModel).then((response)=>{
            if (response.status == true) {
              this.sucMsg = true;
              setTimeout (() => { this.router.navigate(['/show-wearing']);  }, 1500);
            } else {
              this.errMsg = true;
              this.router.navigate(['/']);
            }
          })
         }
      }
}

